import { checkIfMobile } from "../../helpers/views.js";
import useDevice from "../useDevice.js";
export const useIsMobile = ()=>{
    const device = useDevice();
    return checkIfMobile(device);
};
export default useIsMobile;

//# sourceMappingURL=useIsMobile.js.map